import React, { useState } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Button,
  Alert
} from '@mui/material';
import { diagnosticsSftpListDirectory } from '_services/ApiService';
import { SftpCredentialsFields } from './SftpCredentialsFields';

export const SftpCredentialsCard = ({ useJobConfig, testDirectory, subheader }) => {
  const [sftp, setSftp] = useJobConfig(['sftp']);
  const connection = sftp || {};
  const [testStatus, setTestStatus] = useState('');

  const writeSftp = (next) => {
    setSftp(typeof next === 'function' ? next(connection) : next);
    setTestStatus('');
  };

  const testConnection = async () => {
    setTestStatus('testing');
    try {
      const result = await diagnosticsSftpListDirectory({
        credentials: connection,
        directory: testDirectory || '/'
      });
      if (result?.type === 'error') {
        throw new Error(result.message || 'SFTP connection failed');
      }
      setTestStatus('ok');
    } catch (error) {
      setTestStatus(error.message || 'SFTP connection failed');
    }
  };

  return (
    <Card>
      <CardHeader subheader={subheader} title="SFTP connection" />
      <CardContent>
        <SftpCredentialsFields connection={connection} onChange={writeSftp} />

        <Button
          color="primary"
          onClick={testConnection}
          sx={{ marginTop: 2, display: 'block' }}
          variant="contained"
        >
          Test connection
        </Button>
        {testStatus === 'ok' && (
          <Alert severity="success" sx={{ marginTop: 2 }}>
            SFTP connection succeeded.
          </Alert>
        )}
        {testStatus && testStatus !== 'ok' && testStatus !== 'testing' && (
          <Alert severity="error" sx={{ marginTop: 2 }}>
            {testStatus}
          </Alert>
        )}
        {testStatus === 'testing' && (
          <Alert severity="info" sx={{ marginTop: 2 }}>
            Connecting…
          </Alert>
        )}
      </CardContent>
    </Card>
  );
};
